if (typeof window !== "undefined") {
  require("jquery");
  require("popper.js");
  require("bootstrap/dist/js/bootstrap");
}
import $ from 'jquery';
import "@/styles/app.scss";
import { DefaultSeo } from 'next-seo';
import SEO from '../../config/seo.config';
import Script from 'next/script';

export default function App({ Component, pageProps }) {
  return (
    <>
      <DefaultSeo {...SEO}/>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=G-XXXXXXXXXX`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-X4NQW0DX94');
        `}
      </Script>
      <Component {...pageProps} />;
    </>
  )
  

}
